export default "__VITE_ASSET__AZcFkrBB__"